// my API（api/v2/admin/my.php）の compromised_password は 1（漏えい）/ 0（漏えいなし・判定不能）。
// 警告表示の feature flag が無効な施設ではキー自体が返らないため、1 のときだけ漏えい対象とみなす
export const isCompromisedPassword = (my: { compromised_password?: unknown } | null | undefined): boolean => {
  const value = my?.compromised_password;
  return value === 1 || value === '1';
};
